import React from 'react'

/**
 * Dois quadrados sobrepostos com um "+": criar uma cópia. Diferente de
 * `IconeCopiar` (só os quadrados), que na condição especial já significa
 * "copiar o link do aluno" — usar o mesmo ícone deixaria os dois botões
 * indistinguíveis na linha da listagem.
 */
export default (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM19 11H15V15H13V11H9V9H13V5H15V9H19V11Z"
      fill="inherit"
    />
  </svg>
)
